import { styled as o } from "styled-components";
import { Button as n } from "../Button/index.js";
import { CouponStamp as d } from "../CouponStamp/index.js";
import { CopyButton as p } from "../CopyButton/index.js";
import { Skeleton as s } from "../Skeleton/index.js";
import { Theme as t } from "../../styles/themes/index.js";
import { MediaQuery as i } from "../../styles/variables.js";
import { H1Heavy as e, H3Heavy as r, BodyHeavy as m } from "../../styles/typography/index.js";
const f = o.div`
  width: 100%;
  padding: ${`${t.spacings[3]} ${t.spacings[2]}`};
  border-radius: ${t.spacings[4]};
  border: 1px solid rgb(${t.colors.Golf});
  background-color: rgb(${t.colors.Juliet});
  display: grid;
  gap: ${t.spacings[2]};
  grid-template-areas:
    'header'
    'buttons';

  @media ${i.SCREEN_MD_UP} {
    border-radius: ${t.spacings[2]};
    grid-template-areas: 'header buttons';
    grid-template-columns: 1fr auto;
    padding: ${t.spacings[4]};
    gap: ${t.spacings[4]};
  }
`, C = o(s)`
  width: 100%;
  border-radius: 16px;
  height: 136px;

  @media ${i.SCREEN_MD_UP} {
    height: 124px;
    border-radius: 8px;
  }
`, v = o(d)`
  ${e}
  min-width: 124px;
  color: rgb(${t.colors.Brand});

  small {
    ${r}
  }

  span {
    ${e}
    ${({ valueStyle: a }) => a || ""}
  }
`, w = o.div`
  grid-area: header;
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 8px;

  @media ${i.SCREEN_MD_UP} {
    column-gap: 16px;
  }
`, y = o.div`
  width: 100%;
  grid-area: buttons;
  padding: 0 8px;

  @media ${i.SCREEN_MD_UP} {
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: unset;
    min-width: 298px;
    max-width: 298px;
  }
`, E = o.h3`
  ${m}
  color: rgb(${t.colors.Alpha});
  text-align: left;
  text-decoration: none;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-width: 577px;

  @media ${i.SCREEN_MD_UP} {
    ${r}
  }
`, _ = o(p)`
  margin-bottom: ${t.spacings[3]};
  width: 100%;
`, S = o(n).attrs({
  responsive: !0
})`
  i {
    font-size: ${t.spacings[6]};
    margin-left: 4px;
  }

  @media ${i.SCREEN_MD_UP} {
    margin-top: 0;
  }
`;
export {
  S as ActivateButton,
  w as ActiveCouponCardHeader,
  v as ActiveCouponCardStamp,
  E as ActiveCouponTitle,
  y as ButtonsContainer,
  f as Container,
  _ as CouponButton,
  C as SkeletonContainer
};
